import BaseBlockMap from './BaseBlockMap';
import CalculatorsBankingBlockMap from './CalculatorsbankingBlockMap';


export default {
    ...BaseBlockMap,
    ...CalculatorsBankingBlockMap,
};
